<template>
    <footer class="footer mt-auto pt-3 text-light text-dimmed">
        <section>
            <div class="container text-center text-md-start">
                <div class="row mt-3">
                    <div class="col-md-4 col-lg-4 col-xl-4 mb-4">
                        <h6 class="text-uppercase fw-bold mb-4">
                            Taalporno
                        </h6>
                        <p>
                            Woordspelingen waar je een harde plasser van krijgt.
                        </p>
                    </div>

                    <div class="col-md-4 col-lg-4 col-xl-4 mb-4">
                        <h6 class="text-uppercase fw-bold mb-4">
                            Meer Taalporno
                        </h6>
                        <p>
                            <i class="fab fa-instagram me-3"></i> <a href="https://www.instagram.com/taalpurno"
                                target="_blank" class="text-reset">Instagram</a>
                        </p>
                        <p>
                            <i class="fab fa-facebook me-3"></i> <a
                                href="https://www.facebook.com/profile.php?id=100067980660518" target="_blank"
                                class="text-reset">Facebook</a>
                        </p>
                    </div>

                    <div class="col-md-4 col-lg-4 col-xl-4 mb-md-0 mb-4">
                        <h6 class="text-uppercase fw-bold mb-4">Contact</h6>
                        <p><i class="fas fa-envelope me-3"></i>taalwellustigheden@outlook.com</p>
                    </div>
                </div>
            </div>
        </section>

        <div class="text-center p-4" style="background-color: rgba(0, 0, 0, 0.6);">
            © {{ getYear() }} - <router-link to="/" class="text-reset">Taalporno</router-link>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'FooterBar',
    methods: {
        getYear() {
            return new Date().getFullYear();
        }
    }
}
</script>

<style scoped lang="scss">
@import '../scss/theme.scss';

footer {
    background-color: $tp_pink;
}
</style>